package com.eladfinish.bible.contest.features.verseWidget

import com.eladfinish.bible.contest.analytics.AnalyticsConstants
import com.eladfinish.bible.contest.repository.analytics.FirebaseAnalyticsRepository

/**
 * Keeps the widget's user properties true, so that retention, usage and ads can be compared between users by
 * what they chose (docs/analytics/verse-widget.md):
 *  - `has_verse_widget`, true to the home screens, left alone where the platform cannot count widgets;
 *  - the settings ([VerseWidgetAnalytics.userProperties]), only for a user who has a widget or who changed a
 *    setting, so that a user who never touched the feature carries nothing. They stay after the widget is
 *    removed, as what the user last chose, and `has_verse_widget` = false tells those apart.
 */
class UpdateVerseWidgetUserPropertyUseCase(
    private val host: VerseWidgetHost,
    private val configRepository: VerseWidgetConfigRepository,
    private val firebaseAnalyticsRepository: FirebaseAnalyticsRepository,
) {

    operator fun invoke() {
        val installed = host.installedCount()
        if (installed != null) {
            firebaseAnalyticsRepository.setUserProperty(
                key = AnalyticsConstants.VerseWidget.USER_PROPERTY_HAS_WIDGET,
                value = (installed > 0).toString(),
            )
        }
        val hasWidget = (installed ?: 0) > 0
        // A read of a config that was never stored would store a default, and so make the user look like one who set up
        if (!hasWidget && !configRepository.hasStoredConfig()) return
        val config = configRepository.get()
        if (!hasWidget && VerseWidgetAnalytics.isDefault(config)) return

        VerseWidgetAnalytics.userProperties(config).forEach { (key, value) ->
            firebaseAnalyticsRepository.setUserProperty(key = key, value = value)
        }
    }
}
